<template>

<div class="wrapper">
    <div class="str-logo">
        <span class="logo-lg">
            <img :src="$root.serverBasePath + '/strata.png'" alt="Strata Connex"
                    height="49px">
        </span>
    </div>

    <div class="content-wrapper">
        <ProcessBar></ProcessBar>

        <div class="content-wrapper-form">
            <div class="register-form">
                <h2 class="text-center mb-3 font-weight-bold">
                    Hey {{ $store.state.authenticatedUserData.user.first_name }},
                </h2>
                <h3 class="text-center name-subhead py-2">Thanks for your application!</h3>
                <p class="text-center sub--title">
                    Short description about Strata Connex’s <br> value proposition or
                    irresistable offer.
                </p>
                <hr />
                <div
                    class="prfle-completion-box py-1 px-4"
                >
                    <h2 class="text-center prfle-complete mb-2">
                        Compliance Profile Completion
                    </h2>
                    <p class="text-center px-3 sub-prfle-txt sub-title sub--title pt-2">
                        Complete the following steps to have your compliance documents verified, or to have access to the compliance details of your contractors.
                    </p>
                    <div class="progress-tab">
                        <b-progress
                            :max="29"
                            class="mb-3"
                        ></b-progress>
                    </div>
                    <p class="text-center progressbar-text">29% <span>Done</span></p>

                    <div class="under-review-box px-5 py-3 mb-4">
                        <h5 class="circle">Your application is under review.</h5>
                        <p class="h-txt">Short description about what is<br> happening.</p>
                    </div>

                    <b-button
                        type="button"
                        variant="primary"
                        class="btn-grad mx-auto"
                        style="display: table;"
                        :to="{ name: 'register-contractor', params: { step: 2 } }"
                        >Start</b-button
                    >
                </div>
            </div>
        </div>

    </div>
    <FooterComponent />
</div>

</template>

<script>
import ProfileNav from "../../../../pages/includes/ProfileNav.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import ProcessBar from "../../../../frontend/pages/includes/ProcessBar.vue";

export default {
    components: {
    ProcessBar,
    FooterComponent,
    ProfileNav,
  },
};
</script>

<style scoped>
p
{
    font-size: 15px;
}

p.sub--title {
    line-height: 1.5;
}

p.h-txt {
    margin-bottom: 0 !important;
    font-size: clamp(.75rem, 3vw, .9rem);
}

.prfle-complete {
    font-size: clamp(.85rem, 5vw, 1.125rem);
}


@media(max-width: 375px)
{
    p
    {
        font-size: 11px;
    }

    .prfle-complete
    {
        font-size:17px;
    }
    .sub-prfle-txt
    {
        line-height: 20px !important;
    }
}

</style>

